import React from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import styled from "styled-components";
const NavLinkCustom = styled<any>(NavLink)`
  border-radius: ${(props: any) =>
    props.isFirstIndex
      ? "8px 0px 0px 8px !important"
      : props.isLastIndex
      ? "0px 8px 8px 0px !important"
      : "0px 0px 0px 0px !important"};
  cursor: pointer;
  display: flex !important;
  height: 100%;
  justify-content: center;
  padding: 10px 12px !important;
  color: ${(props: any) => (props.isActive ? "#FFF" : "#757575")};
  background-color: ${(props: any) =>
    props.isActive ? "#00B0F5 !important" : "#fff !important"};
`;
interface Tab {
  label: string;
  component: JSX.Element;
}

interface CustomTabsProps {
  tabs: Tab[];
  className: string;
  activeTab: number;
  setActiveTab: any;
  customTabCSS?: any;
  customContentCSS?: any;
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  className,
  activeTab,
  setActiveTab,
  customTabCSS,
  customContentCSS,
}: any) => {
  const toggleTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };
  return (
    <div className="h-100">
      <Nav tabs className={customTabCSS}>
        {tabs.map((tab: any, index: number) => (
          <NavItem key={index} className="customNavItem">
            <NavLinkCustom
              isFirstIndex={index === 0}
              isLastIndex={index == tabs.length - 1}
              isActive={activeTab == index ? true : false}
              onClick={() => toggleTab(index)}
            >
              <span
                className={
                  activeTab === index
                    ? "activeTabText" + className
                    : "inActiveTabText" + className
                }
              >
                {tab.label}
              </span>
            </NavLinkCustom>
          </NavItem>
        ))}
      </Nav>
      <TabContent
        activeTab={activeTab}
        className={customContentCSS ? customContentCSS : "customTabContent"}
      >
        {tabs.map((tab: any, index: number) => (
          <TabPane key={index} tabId={index}>
            {activeTab === index && tab.component}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};

export default CustomTabs;
